<template>
  <div class="p-a i-0 bc-brand show-mob-only z-100">
    <div class="p-a pos-center tt-up d-f fd-c ta-c g w-100">
      <p>This view isn't yet available on mobile.
        <br>Please use desktop in the meantime.</p>
      <p class="link underline" @click="goBack">Go back to previous page</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotAvailableOnMobile",
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1); // Go back one step
      } else {
        this.$router.push("/"); // Navigate to the home page
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
